export const initialOrderHdListingsForm = {
    descriptor: "",
    message: "Please contact me regarding adding HD content to a listing."
};
export var pathsOrderHdListingsForm = {
// Note: populated in reducer
};
